import MKTypography from "../../../components/MKTypography";

export const legalbar = (
  <MKTypography variant="button" fontWeight="regular">
    Emtay B.V. &nbsp;-&nbsp; KvK: 96173114 &nbsp;-&nbsp;
    <MKTypography
      component="a"
      href="mailto:info@emtay.com"
      target="_blank"
      rel="noreferrer"
      variant="button"
      fontWeight="regular"
    >
      info@emtay.com
    </MKTypography>
    &nbsp;-&nbsp;
    <MKTypography
      component="a"
      href="tel:+31658919699"
      target="_blank"
      rel="noreferrer"
      variant="button"
      fontWeight="regular"
    >
      +31 6 58919699
    </MKTypography>
  </MKTypography>
);
